
/**
 *Capitalizes the first letter of the text box value
 *
 * @export
 * @param {*} textBox
 */
export function capitalizeTextBox(textBox){
    textBox.val(capitalize(textBox.val()));
}

/**
 *Capitalizes the first letter of the specified text
 *
 * @param {*} text
 * @returns
 */
function capitalize(text) {
    if (typeof text !== 'string') return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}
